import React from "react";
import { Alert, Form } from "react-bootstrap";

type CollectionMeta = {
  count?: number;
  size_bytes?: number;
};

export type CollectionsMap = Record<string, CollectionMeta>;

type Props = {
  collections: CollectionsMap | null | undefined;
  restoreAll: boolean;
  selected: Record<string, boolean>;
  onChangeRestoreAll: (next: boolean) => void;
  onToggleCollection: (name: string) => void;
};

const formatNumber = (n: number) => {
  try {
    return new Intl.NumberFormat().format(n);
  } catch {
    return String(n);
  }
};

export default function CollectionSelector({
  collections,
  restoreAll,
  selected,
  onChangeRestoreAll,
  onToggleCollection,
}: Props) {
  const names = Object.keys(collections || {}).sort((a, b) => (a < b ? -1 : 1));

  return (
    <div>
      <Form.Check
        type="checkbox"
        id="restore-all-collections"
        label={`Restore All Collections (${names.length} collections)`}
        checked={restoreAll}
        onChange={(e) => onChangeRestoreAll(e.target.checked)}
      />

      {!restoreAll && (
        <div className="mt-3">
          <Form.Label>Select Specific Collections</Form.Label>
          {names.length === 0 ? (
            <Alert variant="info" className="mb-0">
              No collection metadata available for this backup.
            </Alert>
          ) : (
            <div className="d-flex flex-column gap-2">
              {names.map((name) => {
                const meta = (collections || {})[name] || {};
                const count = typeof meta.count === "number" ? meta.count : null;
                const label =
                  count === null ? name : `${name} (${formatNumber(count)} documents)`;

                return (
                  <Form.Check
                    key={name}
                    type="checkbox"
                    id={`restore-collection-${name}`}
                    label={label}
                    checked={!!selected[name]}
                    onChange={() => onToggleCollection(name)}
                  />
                );
              })}
            </div>
          )}
        </div>
      )}
    </div>
  );
}

